module.exports = __webpack_public_path__ + "static/Especialistas_Contct_Tracing_Bandage-a49d36e68dbf2693830c505f1a3b631b.png";